// extracted by mini-css-extract-plugin
module.exports = {"personalMain":"PersonalDetails_personalMain__1bbx7","details":"PersonalDetails_details__2XHeH"};